var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFilter = function SvgIconFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.235C0 .553.553 0 1.235 0h13.53a1.235 1.235 0 0 1 .95 2.023L10 8.93v4.01a1.06 1.06 0 0 1-1.71.837l-1.902-1.484A.993.993 0 0 1 6 11.506V8.931L.284 2.023A1.235 1.235 0 0 1 0 1.235ZM1.235 1a.235.235 0 0 0-.18.385l5.83 7.046A.5.5 0 0 1 7 8.75v2.756l1.878 1.482c.038.009.05.012.063.012.034 0 .059-.025.059-.06V8.75a.5.5 0 0 1 .116-.319l5.83-7.046A.236.236 0 0 0 14.766 1H1.236Z",
    fill: "#006DFF"
  })));
};
export default SvgIconFilter;